import React from 'react';
import PropTypes from 'prop-types';

import styles from './EventCardCTAButton.module.scss';
import ICONS from '../../static/media/icons/icons-helper';

const EventCardCTAButton = ({ title, url, target }) => {
  return (
    <div className={styles.container}>
      <a
        className={styles.link}
        href={url}
        target={target === 'external' ? '_blank' : '_self'}
      >
        {title}
        <img
          className={styles.arrowIcon}
          src={ICONS.RIGHT_ARROW}
          alt="icon-img"
        />
      </a>
    </div>
  );
};

EventCardCTAButton.propTypes = {
  title: PropTypes.string.isRequired,
  target: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default EventCardCTAButton;
